import { Injectable } from '@angular/core';
import { gsap, Quad, TimelineMax, TweenLite, Power0, Power1, Power2, Elastic, Linear } from 'gsap';

import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
gsap.registerPlugin(ScrollToPlugin);

@Injectable({
  providedIn: 'root',
})
export class GsapService {
  
  private eSidebar = '#master_sidebar';
  private eNav1 ="#trg_sidebar span#nav1";
	private eNav2 = "#trg_sidebar span#nav2";
	private eNav3 = "#trg_sidebar span#nav3";

  private eOutsiderBox = '#bwa-lock';
  private ePic1 = ".pic01-2";
  private ePic2 = ".pic01-3";
  private ePic3 = ".pic01-4";
  private ePic4 = ".pic01-5";
  private ePic5 = ".pic01-6";

  public init_setup(){
		TweenLite.to(this.eNav1, .1, { y: -20, opacity: 0, ease: Linear.easeNone });
		TweenLite.to(this.eNav2, .1, { y: -20, opacity: 0, ease: Linear.easeNone });
		TweenLite.to(this.eNav3, .1, { y: -20, opacity: 0, ease: Linear.easeNone });
    
    TweenLite.to("#bwa-lock .logo", .1, { opacity: 0, ease: Linear.easeNone });
    TweenLite.to("#bwa-lock input[type='password']", .1, { opacity: 0, y: -20, ease: Linear.easeNone });
    TweenLite.to("#bwa-lock a", .1, { opacity: 0, scale: 0, ease: Linear.easeNone });

  }
  public anima_full() {
    var tlInit = new TimelineMax();
    
    tlInit.add(TweenLite.to(this.eNav1, .5, { opacity: 1, y: 0, ease: Linear.easeInOut }), 2.1);
		tlInit.add(TweenLite.to(this.eNav2, .4, { opacity: 1, y: 0, ease: Linear.easeInOut }), 2.3);
		tlInit.add(TweenLite.to(this.eNav3, .3, { opacity: 1, y: 0, ease: Linear.easeInOut }), 2.5);

    tlInit.play();
    
  }
  public anima_cart() {
    //var tlInit = new TimelineMax({ repeat: -1 });
    var tlInit = new TimelineMax();
    tlInit.add(TweenLite.to(".pic", .2, { opacity: 0, y: 0, ease: Linear.easeInOut }), 0);
    
    tlInit.add(TweenLite.to(this.ePic1, .4, { opacity: 1, y: 0, ease: Linear.easeInOut }), 0.5);
    tlInit.add(TweenLite.to(this.ePic2, .4, { opacity: 1, y: 0, ease: Linear.easeInOut }), 2.5);
    tlInit.add(TweenLite.to(this.ePic3, .4, { opacity: 1, y: 0, ease: Linear.easeInOut }), 3.6);
    tlInit.add(TweenLite.to(this.ePic4, .4, { opacity: 1, y: 0, ease: Linear.easeInOut }), 5.2);
    tlInit.add(TweenLite.to(this.ePic5, .4, { opacity: 1, y: 0, ease: Linear.easeInOut }), 7.77);
    
    tlInit.play();
    
  }

  public anima_trg(p_which:string, p_action:string="") {
    var tlBase = new TimelineMax();
    var tlBg = new TimelineMax({ repeat: -1 });

    switch(p_which) {

      case "scrolltop": 
        gsap.to("html", { duration: 0.36, scrollTo: { y: 0 } });
        break;

      case "scrollbottom": 
        gsap.to("#box_pages", { duration: 0.72, scrollTo: { y: 999999999 } });
        break;

      case "sidebar_close":
        TweenLite.to(this.eSidebar, .2, { right: "-101%", ease: Linear.easeNone });
        TweenLite.to("#fakelayer_sidebar", .2, { display: "none", ease: Linear.easeNone });
        break;

      case "sidebar_open":
        gsap.to(this.eSidebar, { duration: .2, right: "0", ease: Linear.easeNone });
        gsap.to("#fakelayer_sidebar", { duration: .2, display: "block", ease: Linear.easeNone });
        break;
      
      case "outsider":
        if (p_action == "init") {
          tlBase.add(TweenLite.to("#bwa-lock .logo", .34, { opacity: 1, ease: Linear.easeNone }), 0);
          tlBase.add(TweenLite.to("#bwa-lock input[type='password']", .34, { opacity: 1, y: 0, ease: Linear.easeNone }), .3);
          tlBase.add(TweenLite.to("#bwa-lock a", .43, { opacity: 1, scale: 1, ease: Linear.easeIn }), .7);
        }
        if (p_action == "denied" || p_action == "denied2") {
          //console.log(p_page + '> access denied');
          tlBase.add(TweenLite.to(this.eOutsiderBox, .34, { background: "#2d0202", ease: Linear.easeNone }), 0);
          tlBase.add(TweenLite.to("#outsider_wrapper .frm", .34, { background: "#2d0202", ease: Linear.easeNone }), 0);
          tlBase.add(TweenLite.to(this.eOutsiderBox, .34, { background: '#000', ease: Linear.easeNone }), 1.2);
          tlBase.add(TweenLite.to("#outsider_wrapper .frm", .34, { background: '#000', ease: Linear.easeNone }), 1.2);
        }
        break;

      case "init-preh-setup":
        tlBase.add(TweenLite.to("#page_joinus .step", .1, { opacity: 0, ease: Linear.easeNone }), 0);
        tlBase.add(TweenLite.to("#page_joinus #init div", .1, { opacity: 0, y: 0, ease: Linear.easeNone }), .1);
        tlBase.add(TweenLite.to("#page_joinus #init h2", .1, { opacity: 0, y: 0, ease: Linear.easeNone }), .2);
        tlBase.add(TweenLite.to("#page_joinus #init p", .1, { opacity: 0, y: 0, ease: Linear.easeNone }), .3);
        tlBase.add(TweenLite.to("#page_joinus #init a", .1, { opacity: 0, y: 0, ease: Linear.easeNone }), .4);
        //tlBase.add(TweenLite.to("#page_joinus #init", .1, { opacity: 1, ease: Linear.easeNone }), 5);
        
        break;

      case "init-preh":
        gsap.to("#page_joinus #init .bgimg1", { duration: 3, opacity: .36, x: 0, ease: Linear.easeNone });
        
        tlBase.add(TweenLite.to("#page_joinus #init", .1, { opacity: 1, ease: Linear.easeNone }), 0);
        tlBase.add(TweenLite.to("#page_joinus #init .head", .4, { opacity: 1, y: 0, ease: Linear.easeNone }), .1);
        tlBase.add(TweenLite.to("#page_joinus #init .head h2", .4, { opacity: 1, y: 0, ease: Linear.easeNone }), .3);
        tlBase.add(TweenLite.to("#page_joinus #init .head p", .4, { opacity: 1, y: 0, ease: Linear.easeNone }), .5);
        tlBase.add(TweenLite.to("#page_joinus #init .splitter", .4, { opacity: 1, y: 0, ease: Linear.easeNone }), .7);
        tlBase.add(TweenLite.to("#page_joinus #init > p", .4, { opacity: 1, y: 0, ease: Linear.easeNone }), .9);
        tlBase.add(TweenLite.to("#page_joinus #init a", .4, { opacity: 1, y: 0, ease: Linear.easeNone }), 1.1);
        tlBase.add(TweenLite.to("#page_joinus #init .warning", .4, { opacity: 1, y: 0, ease: Linear.easeNone }), 1.2);
        tlBase.add(TweenLite.to("#page_joinus #init .warning h2", .4, { opacity: 1, y: 0, ease: Linear.easeNone }), 1.3);
        tlBase.add(TweenLite.to("#page_joinus #init .warning p", .4, { opacity: 1, y: 0, ease: Linear.easeNone }), 1.4);
        
        tlBase.add(TweenLite.to("#page_joinus #location", .34, { opacity: 1, y: 0, ease: Linear.easeNone }), 1.8);
        tlBase.add(TweenLite.to("#master-footer", .4, { opacity: 1, y: 0, ease: Linear.easeNone }), 2.1);

        tlBg.add(TweenLite.to("#page_joinus #init .bgimg1", 1.8, { x: -3, ease: Linear.easeNone }), 3.6);
        tlBg.add(TweenLite.to("#page_joinus #init .bgimg1", 1.8, { x: 0, ease: Linear.easeNone }), 5.4);
        
        
        
        break;

      case "init-preh-step1":
        gsap.to("#page_joinus .container", { duration: .2, opacity: 1, background: "transparent", ease: Linear.easeNone });
        gsap.to("#page_joinus .step .bgimg2", { duration: 2.5, opacity: .43, x: 0, ease: Linear.easeNone });
        tlBase.add(TweenLite.to("#page_joinus .bgimg1", .2, { opacity: 0, ease: Linear.easeNone }), 0);

        tlBase.add(TweenLite.to("#page_joinus #init", .3, { opacity: 0, ease: Linear.easeNone }), 0);
        tlBase.add(TweenLite.to("#page_joinus #step1", .34, { display: "block", opacity: 1, y: 0, ease: Linear.easeNone }), .3);
        tlBase.add(TweenLite.to("#page_joinus #step1 h2", .34, { opacity: 1, ease: Linear.easeNone }), 0.4);
        tlBase.add(TweenLite.to("#page_joinus #step1 p", .34, { opacity: 1, ease: Linear.easeNone }), 0.6);
        tlBase.add(TweenLite.to("#page_joinus #step1 div", .34, { opacity: 1, ease: Linear.easeNone }), 0.8);
        tlBase.add(TweenLite.to("#page_joinus #step1 a", .34, { opacity: 1, ease: Linear.easeNone }), 1);
        tlBase.add(TweenLite.to("#page_joinus #step1 .frmname", .34, { opacity: 1, display: "block", ease: Linear.easeNone }), 1);
       
        tlBase.add(TweenLite.to("#page_joinus #location", .34, { opacity: 1, y: 0, ease: Linear.easeNone }), 2.1); 
        break;

      case "init-preh-step2":
        
      gsap.to("#page_joinus .container", { duration: .2, opacity: 1, background: "transparent", ease: Linear.easeNone });
        gsap.to("#page_joinus .step .bgimg2", { duration: 2.5, opacity: .3, x: 0, ease: Linear.easeNone });
        tlBase.add(TweenLite.to("#page_joinus .bgimg1", .2, { opacity: 0, ease: Linear.easeNone }), 0);
        
        // gsap.to("#page_joinus .step .bgimg3", { duration: 2.5, opacity: .43, x: 0, ease: Linear.easeNone });
        // tlBase.add(TweenLite.to("#page_joinus .bgimg2", .3, { opacity: 0, ease: Linear.easeNone }), 0);
        tlBase.add(TweenLite.to("#page_joinus #step1 .frmname", .3, { opacity: 0, ease: Linear.easeNone }), 0);
        tlBase.add(TweenLite.to("#page_joinus #step1 .frmname", .2, { display: "none", ease: Linear.easeNone }), .3);
        tlBase.add(TweenLite.to("#page_joinus #step1 .frmmail", .4, { opacity: 1, display: "block", ease: Linear.easeNone }), .5);
      
        tlBase.add(TweenLite.to("#page_joinus #location", .34, { opacity: 1, y: 0, ease: Linear.easeNone }), 2.1);
        break;

      case "init-preh-step3":
        //gsap.to("#page_joinus .step .bgimg3", { duration: 2.5, opacity: .3, x: 0, ease: Linear.easeNone });
        //tlBase.add(TweenLite.to("#page_joinus .bgimg2", .3, { opacity: 0, ease: Linear.easeNone }), 0);
        
        // gsap.to("#page_joinus .step .bgimg4", { duration: 2.5, opacity: .43, x: 0, ease: Linear.easeNone });
        // tlBase.add(TweenLite.to("#page_joinus .bgimg3", .3, { opacity: 0, ease: Linear.easeNone }), 0);
        tlBase.add(TweenLite.to("#page_joinus #step1 .frmmail", .2, { opacity: 0, ease: Linear.easeNone }), 0);
        tlBase.add(TweenLite.to("#page_joinus #step1 .frmmail", .2, { display: "none", ease: Linear.easeNone }), .3);
        tlBase.add(TweenLite.to("#page_joinus #step1 .frmphone", .4, { opacity: 1, display: "block", ease: Linear.easeNone }), .5);
        
        tlBase.add(TweenLite.to("#page_joinus #location", .34, { opacity: 1, y: 0, ease: Linear.easeNone }), 2.1);
        break;

      case "init-preh-step4":
        gsap.to("#page_joinus .step .bgimg4", { duration: 2.5, opacity: .3, x: 0, ease: Linear.easeNone });
        tlBase.add(TweenLite.to("#page_joinus .bgimg2", .3, { opacity: 0, ease: Linear.easeNone }), 0);
        
        tlBase.add(TweenLite.to("#page_joinus input", .1, { opacity: 0, zIndex: -1, ease: Linear.easeNone }), 0);
        tlBase.add(TweenLite.to("#page_joinus .btn.second-line", .2, { opacity: 0, ease: Linear.easeNone }), .1);
        tlBase.add(TweenLite.to("#page_joinus .btn.primary-line", .3, { opacity: 0, ease: Linear.easeNone }), .3);
        tlBase.add(TweenLite.to("#page_joinus .btn.primary-txt", .4, { opacity: 1, display: "block", ease: Linear.easeNone }), .7);
          
        tlBase.add(TweenLite.to("#page_joinus .stepicon", .4, { opacity: .21, ease: Linear.easeNone }), .7);
        
        tlBase.add(TweenLite.to("#page_joinus #location", .34, { opacity: 1, y: 0, ease: Linear.easeNone }), 2.1);
        break;

      case "pages-mods.jiu":
        
        tlBase.add(TweenLite.to("#page_modalities .head a .ng-fa-icon", .1, { opacity: .7, border: "1.2px solid var(--gold-1)", ease: Linear.easeNone }), 0);
        tlBase.add(TweenLite.to("#page_modalities .head a p", .3, { opacity: 1, fontWeight: "100", ease: Linear.easeNone }), 0);
        tlBase.add(TweenLite.to("#page_modalities .window .tabs", .2, { opacity: 0, ease: Linear.easeNone }), 0);
        tlBase.add(TweenLite.to("#page_modalities .head .jiu .ng-fa-icon", .4, { opacity: 1, border: "2.1px solid var(--gold-2)", ease: Linear.easeNone }), .1);
        tlBase.add(TweenLite.to("#page_modalities .window .funcional", .2, { display: "none", ease: Linear.easeNone }), .1);
        tlBase.add(TweenLite.to("#page_modalities .window .jiu", .4, { opacity: 1, display: "block", ease: Linear.easeNone }), .3);
        tlBase.add(TweenLite.to("#page_modalities .head .jiu p", .3, { opacity: 1, fontWeight: "777", ease: Linear.easeNone }), .3);
        
        gsap.fromTo(
            "#page_modalities .head .jiu .ng-fa-icon",
            {
                scale: .85,
                boxShadow: "0 0 0 rgba(0,0,0,0)"
            },
            {
                duration: .45,
                scale: 1.08,
                boxShadow: "0 0 0 4px rgba(212,175,55,.18),0 0 18px rgba(212,175,55,.45)",
                ease: "back.out(2)"
            }
        );
        break;

      case "pages-mods.funcional":
        
        tlBase.add(TweenLite.to("#page_modalities .head a p", .3, { opacity: 1, fontWeight: "100", ease: Linear.easeNone }), 0);
        tlBase.add(TweenLite.to("#page_modalities .head li a .ng-fa-icon", .1, { opacity: .7, border: "1.2px solid var(--gold-1)", ease: Linear.easeNone }), 0);
        tlBase.add(TweenLite.to("#page_modalities .window .tabs", .2, { opacity: 0, ease: Linear.easeNone }), 0);
        tlBase.add(TweenLite.to("#page_modalities .head .funcional .ng-fa-icon", .4, { opacity: 1, border: "2.1px solid var(--gold-2)", ease: Linear.easeNone }), .1);
        tlBase.add(TweenLite.to("#page_modalities .window .jiu", .2, { display: "none", ease: Linear.easeNone }), .1);
        tlBase.add(TweenLite.to("#page_modalities .window .funcional", .4, { opacity: 1, display: "block", ease: Linear.easeNone }), .3);
        tlBase.add(TweenLite.to("#page_modalities .head .funcional p", .3, { opacity: 1, fontWeight: "777", ease: Linear.easeNone }), .3);
        
        gsap.fromTo(
            "#page_modalities .head .funcional .ng-fa-icon",
            {
                scale: .85,
                boxShadow: "0 0 0 rgba(0,0,0,0)"
            },
            {
                duration: .45,
                scale: 1.08,
                boxShadow: "0 0 0 4px rgba(212,175,55,.18),0 0 18px rgba(212,175,55,.45)",
                ease: "back.out(2)"
            }
        );
        break;

      case "pages-arena.estrutura":
        
        tlBase.add(TweenLite.to("#page_arena .head a p", .3, { opacity: 1, fontWeight: "100", ease: Linear.easeNone }), 0);
        tlBase.add(TweenLite.to("#page_arena .head li a .ng-fa-icon", .1, { opacity: .7, border: "1.2px solid var(--gold-1)", ease: Linear.easeNone }), 0);
        tlBase.add(TweenLite.to("#page_arena .window .tabs", .2, { opacity: 1, ease: Linear.easeNone }), 0);
        tlBase.add(TweenLite.to("#page_arena .head .estrutura .ng-fa-icon", .4, { opacity: 1, border: "2.1px solid var(--gold-2)", ease: Linear.easeNone }), .1);
        //tlBase.add(TweenLite.to("#page_arena .window .comodidades", .2, { display: "none", ease: Linear.easeNone }), .1);
        tlBase.add(TweenLite.to("#page_arena .head .estrutura p", .3, { opacity: 1, fontWeight: "777", ease: Linear.easeNone }), .3);
        tlBase.add(TweenLite.to("#page_arena .window .comodidades", .4, { opacity: 1, ease: Linear.easeNone }), .34);
        
        gsap.fromTo(
            "#page_arena .head .estrutura .ng-fa-icon",
            {
                scale: .85,
                boxShadow: "0 0 0 rgba(0,0,0,0)"
            },
            {
                duration: .45,
                scale: 1.08,
                boxShadow: "0 0 0 4px rgba(212,175,55,.18),0 0 18px rgba(212,175,55,.45)",
                ease: "back.out(2)"
            }
        );
        break;

      case "pages-arena.comodidades":
        
        tlBase.add(TweenLite.to("#page_arena .head a p", .3, { opacity: 1, fontWeight: "100", ease: Linear.easeNone }), 0);
        tlBase.add(TweenLite.to("#page_arena .head li a .ng-fa-icon", .1, { opacity: .7, border: "1.2px solid var(--gold-1)", ease: Linear.easeNone }), 0);
        tlBase.add(TweenLite.to("#page_arena .window .tabs", .2, { opacity: 0, ease: Linear.easeNone }), 0);
        tlBase.add(TweenLite.to("#page_arena .head .comodidades .ng-fa-icon", .4, { opacity: 1, border: "2.1px solid var(--gold-2)", ease: Linear.easeNone }), .1);
        tlBase.add(TweenLite.to("#page_arena .window .estrutura", .2, { display: "none", ease: Linear.easeNone }), .1);
        tlBase.add(TweenLite.to("#page_arena .window .comodidades", .4, { opacity: 1, ease: Linear.easeNone }), .3);
        tlBase.add(TweenLite.to("#page_arena .head .comodidades p", .3, { opacity: 1, fontWeight: "777", ease: Linear.easeNone }), .3);
        
        gsap.fromTo(
            "#page_arena .head .comodidades .ng-fa-icon",
            {
                scale: .85,
                boxShadow: "0 0 0 rgba(0,0,0,0)"
            },
            {
                duration: .45,
                scale: 1.08,
                boxShadow: "0 0 0 4px rgba(212,175,55,.18),0 0 18px rgba(212,175,55,.45)",
                ease: "back.out(2)"
            }
        );
        break;

    }
  }
  
  /*public anima_scrolltop():void {
    var tlScroll = new TimelineMax();
    tlScroll.add(TweenLite.to(document, .7, { scrollTo: { y: 0 } }), .1);

  }*/

}
